var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardsGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gift"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3133 6.66667H2.64667V12C2.64667 14 3.31333 14.6667 5.31333 14.6667H10.6467C12.6467 14.6667 13.3133 14 13.3133 12V6.66667Z",
    stroke: "#9B0000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.3333 4.66667V5.33333C14.3333 6.06667 13.98 6.66667 13 6.66667H3C1.98 6.66667 1.66667 6.06667 1.66667 5.33333V4.66667C1.66667 3.93333 1.98 3.33333 3 3.33333H13C13.98 3.33333 14.3333 3.93333 14.3333 4.66667Z",
    stroke: "#9B0000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.76 3.33333H4.08C3.85333 3.08667 3.86 2.70667 4.1 2.46667L5.04667 1.52C5.29333 1.27333 5.7 1.27333 5.94667 1.52L7.76 3.33333Z",
    stroke: "#9B0000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.9133 3.33333H8.23333L10.0467 1.52C10.2933 1.27333 10.7 1.27333 10.9467 1.52L11.8933 2.46667C12.1333 2.70667 12.14 3.08667 11.9133 3.33333Z",
    stroke: "#9B0000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.96 6.66667V10.0933C5.96 10.6267 6.54667 10.94 6.99333 10.6533L7.62 10.24C7.84667 10.0933 8.13333 10.0933 8.35333 10.24L8.94667 10.64C9.38667 10.9333 9.98 10.62 9.98 10.0867V6.66667H5.96Z",
    stroke: "#9B0000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsGift);
export default __webpack_public_path__ + "static/media/rewards-gift.3ea334c0201828d16393d9493d975352.svg";
export { ForwardRef as ReactComponent };